import React from "react";
import * as yup from "yup";
import * as api from "../../../services/api";
import {useFormik} from "formik";

import {newPasswordValidationSchema} from "../../../services/password/validator";
import {LoadingOverlay} from "../../../components/LoadingOverlay";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import PasswordField from "../../../components/PasswordField";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

const passwordValidationSchema = yup.object().shape({
    currentPassword: yup
        .string()
        .required('Campo obbligatorio'),
}).concat(newPasswordValidationSchema);

const ChangePasswordDialog = (props) => {
    const {onClose} = props;
    const [isSaving, setIsSaving] = React.useState(false);
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const formik = useFormik({
        initialValues: {
            currentPassword: "",
            password: "",
            passwordConfirmation: ""
        },
        validationSchema: passwordValidationSchema,
        validateOnMount: true,
        onSubmit: async (values, actions) => {
            setIsSaving(true);
            try {
                await api.User.updatePassword(values);
                actions.resetForm();
                onClose();
                showSuccessNotification("La tua password è stata modificata")
            } catch (e) {
                showErrorNotification(e);
            }
            setIsSaving(false);
        },
    });

    const disableSave = Object.keys(formik.errors).some(x => formik.touched[x]);

    return (
        <Dialog onClose={onClose} open={true} fullWidth>
            <DialogTitle>Cambia password</DialogTitle>
            <form onSubmit={formik.handleSubmit}  noValidate>
                <DialogContent>
                    <Container maxWidth='sm' disableGutters>
                        <Stack direction="column" spacing={3} sx={{mt: 1}}>
                            <PasswordField
                                required
                                name="currentPassword"
                                value={formik.values.currentPassword}
                                onChange={formik.handleChange}
                                error={formik.touched.currentPassword && Boolean(formik.errors.currentPassword)}
                                helperText={formik.touched.currentPassword && formik.errors.currentPassword}
                                label="Password attuale"
                                autoComplete="current-password"
                                fullWidth
                            />

                            <PasswordField
                                required
                                name="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                label="Nuova password"
                                autoComplete="new-password"
                                fullWidth
                            />

                            <PasswordField
                                required
                                name="passwordConfirmation"
                                value={formik.values.passwordConfirmation}
                                onChange={formik.handleChange}
                                error={formik.touched.passwordConfirmation && Boolean(formik.errors.passwordConfirmation)}
                                helperText={formik.touched.passwordConfirmation && formik.errors.passwordConfirmation}
                                label="Conferma nuova password"
                                autoComplete="new-password"
                                fullWidth
                            />
                        </Stack>
                    </Container>
                </DialogContent>

                <DialogActions sx={{justifyContent: "flex-end", py: 2, px: 3}}>
                    <Button color={"primary"}
                            variant={"text"}
                            onClick={onClose}>
                        Cancella
                    </Button>
                    <Button type="submit"
                            disabled={disableSave}
                            variant="contained">
                        Salva
                    </Button>
                </DialogActions>
            </form>
            <LoadingOverlay isLoading={isSaving}/>
        </Dialog>
    )
};

export default ChangePasswordDialog